import React, { useEffect, useState } from "react";
import { useI18n } from "../i18n/I18nContext";

// Cohort start: June 15, 2026 at 19:30 EST (Haiti time, UTC-5) -> 00:30 UTC June 16
const TARGET = new Date("2026-06-16T00:30:00Z");

export default function Countdown() {
  const { t } = useI18n();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, TARGET.getTime() - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  const Cell = ({ value, label, tid }) => (
    <div data-testid={tid} className="flex flex-col items-center min-w-[78px] md:min-w-[110px]">
      <div className="font-condensed text-5xl md:text-7xl text-[#d4af37] tabular-nums leading-none">
        {String(value).padStart(2, "0")}
      </div>
      <div className="overline mt-2 text-[10px] md:text-xs">{label}</div>
    </div>
  );

  return (
    <div data-testid="countdown" className="flex flex-col items-start md:items-center">
      <div className="overline mb-3">{t("countdown.title")}</div>
      <div className="flex items-end gap-3 md:gap-6">
        <Cell value={days} label={t("countdown.days")} tid="countdown-days" />
        <span className="text-[#d4af37]/50 text-3xl md:text-5xl font-serif pb-3">·</span>
        <Cell value={hours} label={t("countdown.hours")} tid="countdown-hours" />
        <span className="text-[#d4af37]/50 text-3xl md:text-5xl font-serif pb-3">·</span>
        <Cell value={minutes} label={t("countdown.minutes")} tid="countdown-minutes" />
        <span className="text-[#d4af37]/50 text-3xl md:text-5xl font-serif pb-3">·</span>
        <Cell value={seconds} label={t("countdown.seconds")} tid="countdown-seconds" />
      </div>
    </div>
  );
}
